import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "../components/BrandLogo";
import { api } from "../lib/api";

export default function Privacidad() {
  const [t, setT] = useState(null);
  useEffect(() => {
    api.get("/public/privacidad").then((r) => setT(r.data.aviso));
  }, []);
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="px-4 sm:px-8 py-4 border-b bg-white">
        <Link to="/" className="flex items-center"><BrandLogo className="h-8" /></Link>
      </header>
      <main className="max-w-2xl mx-auto p-4 sm:p-8 space-y-4" data-testid="privacy-page">
        <h1 className="font-heading text-3xl font-bold tracking-tight">Aviso de privacidad</h1>
        {t && (
          <>
            <p className="font-mono text-xs text-slate-500">Versión {t.version}</p>
            <pre className="whitespace-pre-wrap font-sans text-base text-slate-700 leading-relaxed">{t.texto.replaceAll("{empresa}", "la empresa que te compartió el enlace")}</pre>
          </>
        )}
      </main>
    </div>
  );
}
